import { createTheme } from "@mui/material";

export const theme = createTheme({
  typography: {
    fontFamily:
      "'Open Sans', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
  },
  components: {
    MuiSnackbar: {
      styleOverrides: {
        width: "100%",
      },
    },
  },
});
